import { red } from '@material-ui/core/colors';

import ErrorIcon from '@material-ui/icons/Error';
import TableManager from "../TableManager/TableManager";
import { RatingBox } from "../RatingBox/RatingBox";
import { useTheme } from "@material-ui/core";
import ButtonActiveIcon from "../../assets/icon/ButtonActiveIcon";

const TableAttendantsManager = ({ loading, attendants }) => {
    const theme = useTheme();
    const columns = [
      { field: 'name', headerName: 'Nombre', width: 200 },
      { 
        field: 'rating', 
        headerName: 'Evaluaciones', 
        width: 150, 
        renderCell: ({ row }) => (
          <RatingBox rating={row.rating} />
        ),
        headerStyle: { textAlign: 'center' },
        cellStyle: { textAlign: 'center' }
      },
      { 
        field: 'avgSupportTime', 
        headerName: 'T.M. de Servicio', 
        width: 150,
        renderCell: ({ row }) => (
          formatTime(row.avgSupportTime)
        ),
        headerStyle: { textAlign: 'center' },
        cellStyle: { textAlign: 'center' }
      },
      { 
        field: 'avgSupportTime', 
        headerName: 'T.M. de Espera', 
        width: 150,
        renderCell: ({ row }) => (
          formatTime(row.avgWaitTime)
        ),
        headerStyle: { textAlign: 'center' },
        cellStyle: { textAlign: 'center' }
      },
      { 
        field: 'online', 
        headerName: 'Estado (Actual)', 
        width: 150, 
        renderCell: ({ row }) => (
          row.online ? 
            <ButtonActiveIcon /> 
            : <ErrorIcon style={{ color: red[600] }} />
        ),
        headerStyle: { textAlign: 'center' },
        cellStyle: { textAlign: 'center' }
      }
    ];
  
    function formatTime(minutes) {
      if (minutes === null || minutes === undefined || isNaN(minutes)) {
        return "0h 0m 0s";
      }

      const totalSeconds = Math.round(minutes * 60);

      const hours = Math.floor(totalSeconds / 3600);
      const mins = Math.floor((totalSeconds % 3600) / 60);
      const secs = totalSeconds % 60;

      return `${hours}h ${mins}m ${secs}s`;
    }
  
    return (
      <TableManager
      backgroundColor={theme.palette.inputBackground}
        columns={columns}
        data={attendants}
        loading={loading}
      />
    );
  };
  
  export default TableAttendantsManager;
  